// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/transfer/style/index.less
// module id = 1075
// module chunks = 1